export default __webpack_public_path__ + "static/media/cheatday_cheesecrisps@3x.1d6360f8.jpg";